//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/base-de-conhecimento/:section',
      en: '/knowledge-base/:section',
      es: '/base-de-conocimientos/:section'
    }
  },

  async asyncData({ $api, params }) {
    try {
      const { data: sectionsItems } = await $api.knowledgeBase.showAll()
      const { section: slug } = params
      const { data: sectionItem } = await $api.knowledgeBase.show(slug)
      const section = sectionItem.section

      const sections = sectionsItems.map((section) => {
        return {
          label: section.title,
          url: `/base-de-conhecimento/${section.slug}`
        }
      })

      return { sections, section }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      sections: [],
      section: {}
    }
  },

  head() {
    const { title, seo } = this.section

    return this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('section'),
      staticDescription: seo ? seo.description : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/base-de-conhecimento'
        },
        {
          name: this.section.title,
          path: this.$route.fullPath
        }
      ]

      return breadcrumbs
    }
  }
}
